import type { Ref } from 'preact/hooks';

export function getValue(
  pageX: number,
  max: number,
  step: number,
  dimensionsRef: Ref<{ width: number; x: number }>,
  isRtl: boolean
): number {
  const dimensions = dimensionsRef.current;
  if (!dimensions || dimensions.width === 0) {
    return -1;
  }
  const width = pageX - dimensions.x;
  const val = (max * (isRtl ? dimensions.width - width : width)) / dimensions.width;
  const numSteps = val / step;
  return numSteps < 0.5 ? 0 : Math.ceil(numSteps) * step;
}

export function getDimensions(element: HTMLElement | null) {
  if (!element) {
    return {
      width: 0,
      x: 0
    };
  }

  const rect = element.getBoundingClientRect();
  return {
    width: Math.round(rect.width),
    x: Math.round(rect.x + window.scrollX)
  };
}
